<main
    *ngIf="distribution"
    class="agpr-distributionReport"
    [agprLoading]="distribLoading || reportLoading"
    #overlayContainer
>
    <section
        class="agpr-distributionReport-center"
        [attr.aria-label]="'Common.layout.main' | localize"
    >
        <h2 class="agpr-distributionReport-name">
            <span> {{ distribution.name }} </span>&nbsp;
            <span class="u-srOnly">{{ 'Discover.pageHeader.distributionReport' | localize }}</span>
        </h2>
        <agpr-message
            *ngIf="!userIsWhiteLabeled"
            class="agpr-amplifyMessage"
            [severity]="messageSeverity.info"
            [toggleable]="true"
            [collapsed]="false"
            [toggleableContent]="buttonsTemplate"
        >
            <p [innerHTML]="'Discover.distributionReport.amplify.message' | localize"></p>
            <ng-template #buttonsTemplate>
                <div class="agpr-amplifyMessage-button-container">
                    <agpr-button
                        class="agpr-amplifyMessage-btn"
                        [disabled]="boosted"
                        (click)="openDisclaimerDialog()"
                    >
                        <div class="agpr-amplifyMessage-button">
                            @if (boosted) {
                                <div class="agpr-amplifyMessage-button--active">
                                    {{ 'Discover.distributionReport.amplify.onlineBoost.heading.active' | localize }}
                                </div>
                            }

                            <span class="agpr-amplifyMessage-button-icon">
                                <span class="fa-regular fa-duotone fa-bolt" aria-hidden="true"></span>
                            </span>
                            <div class="agpr-amplifyMessage-button-detail">
                                <span class="agpr-amplifyMessage-button-title">
                                    {{ 'Discover.distributionReport.amplify.onlineBoost.heading' | localize }}
                                </span>
                                <p class="agpr-amplifyMessage-button-text">
                                    {{ 'Discover.distributionReport.amplify.onlineBoost.text' | localize }}
                                </p>
                            </div>
                        </div>
                    </agpr-button>
                    <!-- TODO: unhide once NEP-5097 is landed-->
                    <agpr-button *ngIf="userHasNewsroomPermission && false" class="agpr-amplifyMessage-btn">
                        <div class="agpr-amplifyMessage-button">
                            <span class="agpr-amplifyMessage-button-icon">
                                <span class="agpr-i-line-bullhorn" aria-hidden="true"></span>
                            </span>
                            <div class="agpr-amplifyMessage-button-detail">
                                <span class="agpr-amplifyMessage-button-title">
                                    {{ 'Discover.distributionReport.amplify.newsroom.heading' | localize }}
                                </span>
                                <p class="agpr-amplifyMessage-button-text">
                                    {{ 'Discover.distributionReport.amplify.newsroom.text' | localize }}
                                </p>
                            </div>
                        </div>
                    </agpr-button>
                    <a
                        *ngIf="userHasNewswirePermission"
                        class="agpr-amplifyMessage-link"
                        href="https://www.agilitypr.com/newswire-provisioning-form/"
                        target="_blank"
                    >
                        <div class="agpr-amplifyMessage-button">
                            <span class="agpr-amplifyMessage-button-icon">
                                <span class="fa-regular fa-duotone fa-globe" aria-hidden="true"></span>
                            </span>
                            <div class="agpr-amplifyMessage-button-detail">
                                <span class="agpr-amplifyMessage-button-title">
                                    {{ 'Discover.distributionReport.amplify.newswire.heading' | localize }}
                                </span>
                                <p class="agpr-amplifyMessage-button-text">
                                    {{ 'Discover.distributionReport.amplify.newswire.text' | localize }}
                                </p>
                            </div>
                        </div>
                    </a>

                </div>
            </ng-template>
        </agpr-message>
        <div class="agpr-distributionReport-center-toolbar">
            <agpr-tabs
                class="agpr-distributionReportTabs"
                [selectedTabIndex]="selectedTabIndex"
                (selectedTabIndexChange)="tabChange($event)"
            >
                <agpr-tab
                    [icon]="'fa-regular fa-duotone fa-gauge-simple-high'"
                    [heading]="'Discover.distributionReport.type.performance'"
                    [id]="'distributionReport.performanceTab'"
                >
                </agpr-tab>
                <agpr-tab
                    [icon]="'fa-regular fa-duotone fa-envelope'"
                    [heading]="'Discover.distributionReport.type.recipient'"
                    [id]="'distributionReport.recipientTab'"
                >
                </agpr-tab>
                <agpr-tab
                    [icon]="'fa-kit fa-agpr-compose'"
                    [heading]="'Discover.distributionReport.type.composition'"
                    [id]="'distributionReport.compositionTab'"
                >
                </agpr-tab>
            </agpr-tabs>
        </div>
        <agpr-scroll-panel>
            <div class="agpr-distributionReport-center-report">
                <agpr-performance-report
                    *ngIf="selectedTabIndex === statisticsReportType.performance"
                    [(enableMppEstimates)]="enableMppEstimates"
                    [sentDate]="distributionScheduledDate"
                    [status]="distribution.status"
                    [isScheduled]="isScheduled"
                    [clickTracking]="distribution.clickTracking"
                    [openTracking]="distribution.openTracking"
                    (mppEstimateChanged)="changeMppEstimates($event)"
                    (selectedLinkChanged)="setSelectLink($event)"
                ></agpr-performance-report>
                <agpr-recipient-report
                    *ngIf="selectedTabIndex === statisticsReportType.recipients"
                    (statTypeSelected)="statTypeSelected($event)"
                    [(enableMppEstimates)]="enableMppEstimates"
                    (mppEstimateChanged)="changeMppEstimates($event)"
                    [sentDate]="distributionScheduledDate"
                    [status]="distribution.status"
                    [isScheduled]="isScheduled"
                    [clickTracking]="distribution.clickTracking"
                    [openTracking]="distribution.openTracking"
                    [recipientTotal]="distribution.recipientInformation.total"
                    [selectedType]="selectedType"
                    [selectedIndividualRecipient]="selectedIndividualRecipient"
                    [targetingLists]="targetingLists"
                    [targetingSearches]="targetingSearches"
                ></agpr-recipient-report>
                <agpr-distribution-header
                    *ngIf="selectedTabIndex === statisticsReportType.composition"
                ></agpr-distribution-header>
                <agpr-composition-report
                    [bodyHtml]="bodyHtml"
                    [bodyPlainText]="bodyPlainText"
                    [footerPlainText]="footerPlainText"
                    *ngIf="selectedTabIndex === statisticsReportType.composition"
                ></agpr-composition-report>
            </div>
        </agpr-scroll-panel>

        <agpr-action-bar>
            <ng-template #left>
                @if (isScheduled) {
                    <agpr-button
                        [label]="'Discover.targeting.actions.cancelDistribution'"
                        (click)="distributionService.cancelDistribution(distribution)"
                    ></agpr-button>
                }
            </ng-template>

            <ng-template #right>
                <agpr-button
                    *ngIf="showExportButton"
                    label="Discover.distributionReport.export"
                    [style]="buttonTypes.primary"
                    (click)="exportReport()"
                ></agpr-button>
            </ng-template>
        </agpr-action-bar>
    </section>

    <aside
        class="agpr-distributionReport-sidebar"
        [attr.aria-label]="'Common.layout.rhp' | localize"
    >
        <agpr-right-sidebar
            #rhp
            [(expanded)]="sidebarExpanded"
            [overlayContainer]="overlayContainer"
            (unfocusEmit)="toggleRhpTakeover($event)"
            [selectedTabIndex]="selectedRHPTabIndex"
            (selectedTabIndexChange)="selectedRHPTabIndex = $event;"
        >
            <agpr-tab
                icon=" fa-file-lines"
                tooltip="Discover.distribution.details.distributionDetails"
                [id]="'distributionComponentSettingsTab'"
            >
                <agpr-attribute-list
                    *ngIf="distributionDetailsAttributes?.length > 0"
                    [attributes]="distributionDetailsAttributes"
                ></agpr-attribute-list>

                <agpr-panel
                    header="Discover.distribution.distribution"
                >
                    <div class="agpr-distributionReport-subject">
                        {{ distribution.subjectLine }}
                    </div>
                    <div class="agpr-distributionReport-previewText">
                        {{ distribution.previewText }}
                    </div>
                    <agpr-attribute-list
                        class="agpr-distributionReport-distributionAttributes"
                        [attributes]="distributionAttributes"
                        [showFullLengthTooltip]="true"
                    ></agpr-attribute-list>
                </agpr-panel>

                <agpr-panel
                    *ngIf="attachmentNames.length > 0"
                    header="Discover.distribution.attachments"
                >
                    <div
                        *ngFor="let attachmentName of attachmentNames"
                        class="agpr-distributionReport-attachment"
                        [pTooltip]="attachmentName"
                        tooltipPosition="top"
                    >
                        <span>{{ attachmentName }}</span>
                    </div>
                </agpr-panel>

                <agpr-message
                    *ngIf="distribution?.status === distributionStatuses.scheduled"
                    [severity]="messageSeverity.warning"
                    class="agpr-distributionReport-recipientsLocked"
                >
                    <p>{{ 'Discover.targeting.distribution.warning.recipientsLocked' | localize }}</p>
                </agpr-message>

                <agpr-panel
                    *ngIf="distribution.confirmationRecipients?.length > 0"
                    header="Discover.distribution.confirmationRecipients"
                >
                    <div
                        *ngFor="let confirmationRecipient of distribution.confirmationRecipients"
                        class="agpr-distributionReport-confirmationRecipient"
                        [pTooltip]="confirmationRecipient"
                        tooltipPosition="top"
                    >
                        <span>{{ confirmationRecipient }}</span>
                    </div>
                </agpr-panel>

                <agpr-panel
                    *ngIf="otherSettingsAttributes?.length > 0"
                    header="Discover.distribution.details.tracking"
                >
                    <agpr-attribute-list
                        [attributes]="otherSettingsAttributes"
                    ></agpr-attribute-list>
                </agpr-panel>
            </agpr-tab>
            <agpr-recipient-search-tab
                [icon]="'fa-regular -duotone fa-users'"
                [tooltip]="'Discover.distribution.recipients'"
                (showRhpTakeOver)="toggleRhpTakeover($event)"
            ></agpr-recipient-search-tab>
        </agpr-right-sidebar>
    </aside>
</main>
